import { Component, input } from '@angular/core';

/** Ícone Material Symbols Outlined. O tamanho segue o font-size (ex.: class="text-3xl"). */
@Component({
  selector: 'app-icon',
  template: '{{ name() }}',
  host: {
    class: 'icon',
    'aria-hidden': 'true',
    '[class.icon-filled]': 'filled()'
  }
})
export class IconComponent {
  readonly name = input.required<string>();
  readonly filled = input(false);
}
